/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FolderControllerAddPermissionsRequestInner { 
    userId?: number;
    companyId?: string;
    permissionLevel?: FolderControllerAddPermissionsRequestInner.PermissionLevelEnum;
}
export namespace FolderControllerAddPermissionsRequestInner {
    export type PermissionLevelEnum = 'viewer' | 'editor' | 'manager' | 'admin';
    export const PermissionLevelEnum = {
        Viewer: 'viewer' as PermissionLevelEnum,
        Editor: 'editor' as PermissionLevelEnum,
        Manager: 'manager' as PermissionLevelEnum,
        Admin: 'admin' as PermissionLevelEnum
    };
}


